module.exports = "<dynamic-html-outlet [src]=\"header\"></dynamic-html-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.html
// module id = 557
// module chunks = 0